export const ACCENTS = ['brand', 'teal', 'blue', 'red', 'amber', 'pink', 'green'];
/** `{ color, bg }` as CSS custom properties — the pair every screen uses for an avatar tile. */
export function accentVars(a) {
    return { color: `var(--${a})`, bg: `var(--${a}-tint)` };
}
/** The stronger text-weight token, where one exists (blue/amber/green); else the base. */
export function accentText(a) {
    if (a === 'blue')
        return 'var(--blue-strong)';
    if (a === 'amber')
        return 'var(--amber-tx)';
    return `var(--${a})`;
}
/** Light-theme hex values (mirror of styles.css `:root`), for hex-only consumers. */
const HEX = {
    brand: { color: '#5b2fcc', bg: '#efe9fc' },
    teal: { color: '#0e8e7f', bg: '#e6f4f1' },
    blue: { color: '#3d6fe3', bg: '#ecf1fd' },
    red: { color: '#cf4c42', bg: '#fbe9e7' },
    amber: { color: '#b07815', bg: '#fbf1de' },
    pink: { color: '#c13d7e', bg: '#fbeaf3' },
    green: { color: '#1c6b41', bg: '#e7f5ed' },
};
export function accentHex(a) {
    return HEX[a];
}
//# sourceMappingURL=accent.js.map